import { Check } from 'lucide-react';

import { cn } from '@sandtech-hub-monorepo/ui-kit';

interface Props {
  title: string;
  items: string[];
  variant?: 'primary' | 'saffron';
  className?: string;
}

export const ValueChecklist = ({
  title,
  items,
  variant = 'primary',
  className,
}: Props) => (
  <div className={cn('flex flex-col gap-4', className)}>
    <h3 className="text-lg font-semibold text-heading">{title}</h3>
    <ul className="flex flex-col gap-3">
      {items.map((item) => (
        <li key={item} className="flex items-start gap-3">
          <Check
            className={cn(
              'mt-0.5 h-5 w-5 shrink-0',
              variant === 'saffron' ? 'text-saffron' : 'text-primary'
            )}
          />
          <span className="text-foreground">{item}</span>
        </li>
      ))}
    </ul>
  </div>
);
